export default __webpack_public_path__ + "static/media/fasihi.0e2fe1a0.png";